const isDevelopment = process.env.REACT_APP_DEPLOYMENT_CONTEXT === "development";
const baseURL = isDevelopment ? "https://cdn.walkfree.org/wp-json/minderberg/gsi/v1" : "/wp-json/minderberg/gsi/v1";

const request = async (url: string) => {
  const response = await fetch(`${baseURL}${url}`, {
    method: "GET",
    headers: {
      Authorization: "Basic Z3NpMjAyMjpzbGF2ZXJ5ZnJlZQ=="
    }
  });
  const data = await response.json();
  return data;
};
const api = {
  GetAllCountries: () => request("/countries"),
  GetCountry: iso => request(`/countries/${iso}`),
  GetImports: () => request("/imports"),
  GetMetadata: () => request("/metadata")
};

export default api;
